import { render, staticRenderFns } from "./AgoraClient.vue?vue&type=template&id=f91232c6"
import script from "./AgoraClient.vue?vue&type=script&lang=js"
export * from "./AgoraClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports